export default __webpack_public_path__ + "static/media/teacher2.821e9cbf.svg";